import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Loader from 'components/Loader/Loader';
import EditExpenseExportPopup from './EditExpenseExportPopup';
const styles = require('./ExpenseExportModels.pcss');

type ExpenseExportModel = {
  id?: string | number;
  templateName?: string;
  status?: string;
  lastExportDate?: string;
  fileExtension?: string;
};

type Props = {
  models: ExpenseExportModel[];
  isLoading: boolean;
};

const ExpenseExportModels = ({ models, isLoading }: Props) => {
  const [selectedModel, setSelectedModel] =
    React.useState<ExpenseExportModel | null>(null);

  const handleSave = (model: ExpenseExportModel) => {
    setSelectedModel(null);
  };

  return (
    <Paper className={styles.card}>
      <h2>Custom Expense Exports</h2>
      {isLoading ? (
        <div className={styles.loader}>
          <Loader visible={true} />
        </div>
      ) : models.length > 0 ? (
        <div className={styles.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Template Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Last Export Date</TableCell>
                <TableCell>File Extension</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {models.map((model) => (
                <TableRow
                  key={model.id ?? model.templateName}
                  hover
                  className={styles.clickableRow}
                  onClick={() => setSelectedModel(model)}
                >
                  <TableCell>{model.templateName ?? 'N/A'}</TableCell>
                  <TableCell>{model.status}</TableCell>
                  <TableCell>{model.lastExportDate ?? `N/A`}</TableCell>
                  <TableCell>{model.fileExtension}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <div className={styles.empty}>No custom expense export models.</div>
      )}
      <EditExpenseExportPopup
        open={selectedModel !== null}
        model={selectedModel}
        onClose={() => setSelectedModel(null)}
        onSave={handleSave}
      />
    </Paper>
  );
};

export default ExpenseExportModels;